import Rautes from "Rautes";

function App() {
  return (

    <Rautes />
  );
}
export default App;
